__turbopack_context__.v({
  "className": "inter_f3e01e7c-module__7TTKpW__className",
  "variable": "inter_f3e01e7c-module__7TTKpW__variable",
});
